"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnCallDutyStatusValues = exports.OnCallDutyStatus = void 0;
var OnCallDutyStatus;
(function (OnCallDutyStatus) {
    OnCallDutyStatus["ACTIVE"] = "ACTIVE";
    OnCallDutyStatus["INACTIVE"] = "INACTIVE";
})(OnCallDutyStatus = exports.OnCallDutyStatus || (exports.OnCallDutyStatus = {}));
exports.OnCallDutyStatusValues = Object.values(OnCallDutyStatus);
